import { apiClient } from './client';
import {
  LoginRequest,
  LoginResponse,
  User,
  RefreshTokenResponse,
} from '../../types/api';

export class AuthService {
  /**
   * Authentifier un utilisateur
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
    return response;
  }

  /**
   * Déconnecter l'utilisateur
   */
  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
    apiClient.clearAuthToken();
  }

  /**
   * Obtenir les informations de l'utilisateur connecté
   */
  async getCurrentUser(): Promise<User> {
    console.log('🔐 [AUTH SERVICE] Récupération de l\'utilisateur actuel...');
    const response = await apiClient.get<User>('/auth/me');
    console.log('🔐 [AUTH SERVICE] Utilisateur récupéré:', response);
    return response;
  }

  /**
   * Rafraîchir le token d'accès
   */
  async refreshToken(): Promise<RefreshTokenResponse> {
    const response = await apiClient.post<RefreshTokenResponse>('/auth/refresh');
    return response;
  }

  /**
   * Vérifier si l'utilisateur est authentifié
   */
  isAuthenticated(): boolean {
    const token = apiClient['getStoredToken']?.();
    console.log('🔐 [AUTH SERVICE] Vérification authentification:', !!token);
    return !!token;
  }

  /**
   * Obtenir le token d'accès actuel
   */
  getToken(): string | null {
    const token = apiClient['getStoredToken']?.() || null;
    console.log('🔐 [AUTH SERVICE] Token actuel:', token ? 'présent' : 'absent');
    return token;
  }

  /**
   * Définir le token d'accès
   */
  setToken(token: string): void {
    apiClient.setAuthToken(token);
  }

  /**
   * Effacer le token d'accès
   */
  clearToken(): void {
    apiClient.clearAuthToken();
  }
}

// Export singleton instance
export const authService = new AuthService();